/**
 * Ideal aralashtirishli reaktor (CSTR) — UnitModel.
 *
 * OGOHLANTIRISH KODLARI (i18n):
 *   reactor.noFlow                critical  F = 0 (reaktor batch kabi)
 *   reactor.runaway               critical  T > Tmax
 *   reactor.multipleSteadyStates  info      bir nechta turg'un holat (params.count)
 *   reactor.noReaction            info      konversiya ≈ 0
 */
import type { UnitModel } from '../../types';
import { initState, stepDynamic } from './dynamic';
import { solveSteady } from './steady';
import { resolveReaction } from '../reaction';
import type { ReactionSpec } from '../reaction';

const NORMALIZED = new WeakMap<object, CstrParams>();
/** `reaction` kutubxona havolasi bo'lsa — konstantalarga ochadi (memoizatsiya obyekt bo'yicha) */
function norm(p: CstrParams): CstrParams {
  const hit = NORMALIZED.get(p);
  if (hit) return hit;
  const r = { ...p, reaction: resolveReaction(p.reaction as unknown as ReactionSpec) };
  NORMALIZED.set(p, r);
  return r;
}
import type {
  CstrInputs,
  CstrParams,
  CstrState,
  CstrStepOutputs,
  CstrSteadyOutputs,
} from './types';

export const cstr: UnitModel<
  CstrParams,
  CstrInputs,
  CstrState,
  CstrStepOutputs,
  CstrSteadyOutputs
> = {
  id: 'cstr',
  resolveParams: norm,
  init: (p, i) => initState(norm(p), i),
  step: (p, s, i, dt) => stepDynamic(norm(p), s, i, dt),
  steady: (p, i) => solveSteady(norm(p), i),
};

export * from './types';
export { solveSteady, outputsFor } from './steady';
export { initState, stepDynamic } from './dynamic';
export * from './balances';
